import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { Citation } from '@frontend/task-center-scope';
import { useGetUserFromUserId, useTaskFormPatient } from '../hooks';
import { getPersonName } from '../utils';

export const useGetCitationPersonName = ({ citation }: { citation?: Citation }) => {
  const messageOutbound = citation?.direction === Direction.DIRECTION_OUTBOUND;
  const { patient, isLoading: isFetchingPatient } = useTaskFormPatient(
    messageOutbound ? undefined : citation?.patient_id
  );
  const { data: senderDetails, isFetching: isFetchingSender } = useGetUserFromUserId(
    citation?.user_id,
    messageOutbound
  );

  const personName = getPersonName(patient, senderDetails);

  return { personName, isLoading: isFetchingPatient || isFetchingSender };
};
